import { Injectable, OnDestroy } from '@angular/core';
import { catchError, Observable, Subject, takeUntil, throwError } from 'rxjs';
import { ConfigService } from './config.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LegalMentionService implements OnDestroy {
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private readonly configService: ConfigService,
    private readonly http: HttpClient
  ) {}

  /**
   * Called when the component is destroyed. Unsubscribes from all subscriptions to prevent memory leaks.
   */
  ngOnDestroy() {
    this._destroying$.next();
    this._destroying$.complete();
  }

  public getLegalMentions(): Observable<any> {
    return this.http
      .get(`${this.configService.config.backendUri}/legal-mentions`, {
        responseType: 'text',
      })
      .pipe(
        takeUntil(this._destroying$),
        catchError((httpErrorResponse: HttpErrorResponse) => {
          const error = httpErrorResponse;
          return throwError(() => error);
        })
      );
  }
}
